import { PLATFORMS, STATUS_PILL } from "../data/mock.js";

export default function Inspector({ ev }) {
  if (!ev) return <aside className="inspector"/>;

  const sold = Object.values(ev.sales).reduce((a,b)=>a+b,0);
  const gross = sold * ev.price;
  const pct = ev.cap ? Math.round(sold/ev.cap*100) : 0;
  const max = Math.max(...Object.values(ev.sales), 1);
  const [h1, h2] = ev.hue.split(",");
  const sp = STATUS_PILL[ev.status];

  const heroBg = `radial-gradient(600px 200px at 80% -40%, hsla(${h1},80%,55%,0.20), transparent 70%),radial-gradient(400px 180px at 0% 100%, hsla(${h2},90%,40%,0.14), transparent 70%),linear-gradient(180deg, var(--bg-2), var(--bg-1))`;

  const sortedPlats = Object.entries(ev.sales).sort((a,b)=>b[1]-a[1]);

  return (
    <aside className="inspector">
      <div className="ins-hero" style={{backgroundImage:heroBg}}>
        <div className="ins-eyebrow"><span>Event detail</span><span className="id">{ev.id}</span></div>
        <div className="ins-title">
          {ev.title.split(" · ")[0]}
          <em>{ev.title.includes(" · ") ? "· " + ev.title.split(" · ")[1] : ev.sub}</em>
        </div>
        <div className="ins-when">{ev.date} · {ev.time}</div>
        <div className="ins-where">{ev.venue} — {ev.city}</div>
        <div style={{marginTop:12,display:"flex",gap:6,alignItems:"center"}}>
          <span className={`pill ${sp.cls}`}>{sp.label}</span>
          {ev.alert && <span className="pill alert">{ev.alert}</span>}
          <span style={{marginLeft:"auto",fontFamily:"var(--mono)",fontSize:11,color:"var(--ink-3)"}}>£{ev.price} face</span>
        </div>
        <div className="ins-bigstats">
          <div className="ins-bigstat"><div className="lbl">Sold</div>
            <div className="val">{sold.toLocaleString()}<span className="small"> / {ev.cap.toLocaleString()}</span></div>
          </div>
          <div className="ins-bigstat"><div className="lbl">Sell-through</div>
            <div className="val">{pct}<span className="small">%</span></div>
          </div>
          <div className="ins-bigstat"><div className="lbl">Gross</div>
            <div className="val">£{(gross/1000).toFixed(1)}<span className="small">k</span></div>
          </div>
        </div>
      </div>

      <div className="ins-section">
        <h3>Per-platform breakdown <span className="right">last 24h</span></h3>
        {sortedPlats.map(([k,v])=>{
          const p = PLATFORMS[k];
          const share = sold ? (v/sold*100).toFixed(1) : "0.0";
          return (
            <div key={k} className="platrow">
              <span className="pdot" style={{background:p.color}}>{p.code}</span>
              <div>
                <div className="pname">{p.name}</div>
                <div className="pmeta">fee {p.fee} · {v ? "synced 02m ago" : "no inventory"}</div>
              </div>
              <div className="pval">
                <b>{v}</b>
                <span>£{(v*ev.price).toLocaleString(undefined,{maximumFractionDigits:0})} · {share}%</span>
              </div>
              <div className="pbar"><span style={{width:`${v/max*100}%`,background:p.color}}/></div>
            </div>
          );
        })}
      </div>

      <div className="ins-section">
        <h3>Live activity feed <span className="right">streaming</span></h3>
        <div className="activity">
          {(ev.activity || [{t:"now",e:"No live activity for this event",v:""}]).map((a,i)=>(
            <div key={i} className="row">
              <span className="t">{a.t}</span>
              <span>{a.e}</span>
              <span className={`v${a.neg?" neg":""}`}>{a.v}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="ins-section" style={{display:"flex",gap:8,flexWrap:"wrap",borderBottom:0}}>
        <button className="btn primary" style={{flex:1}}>Open event</button>
        <button className="btn">Push update to all platforms</button>
        <button className="btn">Door &amp; scan</button>
        <button className="btn">Issue refund</button>
      </div>
    </aside>
  );
}
